import React from 'react'
import { SessionProvider } from '@crunchyroll/cr-static-shared-components'

import DatadogWrapper from '@components/datadog/DatadogWrapper'

const wrapRoot = ({ element }) => (
  <SessionProvider>
    <DatadogWrapper>{element}</DatadogWrapper>
  </SessionProvider>
)
export default wrapRoot
